module.exports = __webpack_public_path__ + "static/images/mytime-logo.7c9215beb64262528830c6ca076a30f9.png";